import { memo } from "react";
import { CloseOutlined as Close24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CloseOutlined";
import { LinkWithoutPrefetch } from "@/components/__shared__/LinkWithoutPrefetch/LinkWithoutPrefetch";
import { removePriceFilter } from "./utils";
import { sanitiseQueryParams } from "@/utils/queryUtils";
import styles from "./AppliedFilters.module.scss";

interface AppliedFilterProps {
  facetName: string;
  label: string;
  trackingId: string;
  facetUrl: string;
  queryWithoutPage: Record<string, string | string[] | undefined>;
  onFilterRemove: (
    facetName: string,
    label: string,
    trackingId: string,
  ) => void;
}

export const AppliedFilter = memo(
  ({
    facetName,
    label,
    trackingId,
    facetUrl,
    queryWithoutPage,
    onFilterRemove,
  }: AppliedFilterProps) => {
    const query = trackingId.startsWith("price=")
      ? removePriceFilter(queryWithoutPage, trackingId)
      : queryWithoutPage;

    return (
      <li className={styles.filter}>
        <LinkWithoutPrefetch
          href={{
            pathname: facetUrl.split("?")[0],
            query: sanitiseQueryParams(query),
          }}
          className={styles.filterLink}
          onClick={() => onFilterRemove(facetName, label, trackingId)}
          data-testid="applied-filter__link"
        >
          <span className={styles.filterLinkText}>{label}</span>
          <div className={styles.filterLinkIcon}>
            <Close24PxOutlinedIcon title="Remove filter" size="medium" />
          </div>
        </LinkWithoutPrefetch>
      </li>
    );
  },
);

AppliedFilter.displayName = "AppliedFilter";
